import * as React from 'react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { matchRoutes, useLocation } from 'react-router-dom';

import {
	Typography,
	Breadcrumbs as MaterialBreadcrumbs,
	Link,
} from '@mui/material';

import { getTranslation } from '@x_x_x/locales';

import { IState } from '@redux';

import { getRouter } from '../../../Router';

import { IBreadcrumbsItem } from '@interfaces';

import { IBreadcrumbsProps } from './types';

import { locales } from './locales';

const t = getTranslation<typeof locales>('@frontend/components.ui.Breadcrumbs');

export const Breadcrumbs = (props: IBreadcrumbsProps) => {
	const location = useLocation();
	const state = useSelector((globalState: IState) => globalState);
	const [items, setItems] = useState<IBreadcrumbsItem[]>([]);

	const initItems = async () => {
		const { routes } = await getRouter();
		const matched = matchRoutes(routes, location.pathname);

		if (matched?.[0]) {
			const route = matched[0].route;
			const component = route.component;
			// eslint-disable-next-line @typescript-eslint/await-thenable
			const breadcrumbs = await component.getBreadcrumbs(state);

			setItems(breadcrumbs);
		}
	};

	useEffect(
		() => {
			void initItems();
		},
		[state],
	);

	return items.length > 0
		? (
			<MaterialBreadcrumbs aria-label="breadcrumb">
				<Link underline="hover" color="inherit" href="/">{t.main}</Link>
				{items.map((item, index) => (
					index === items.length - 1
						? (
							<Typography
								key={index}
								color="text.primary"
							>
								{item.title}
							</Typography>
						)
						: (
							<Link
								key={index}
								underline="hover"
								color="inherit"
								href={item.url}
							>
								{item.title}
							</Link>
						)
				))}
			</MaterialBreadcrumbs>
		)
		: null;
};
